import React, { Component } from "react";
import {Link} from "react-router-dom";
// import style
import "./App.css";
import Logo from "./assets/images/logo.png";

export default class PageNotFound extends React.Component {
  render() {
    return (
        <div className="error404 perfectCenter">
            <img src={Logo}/>
            <div className="heading">
            PAGE NOT FOUND
            </div>
            <Link to="/" >Main page</Link>
        </div>
    );
  }
}
